import styled from "styled-components";

export const LogoWrapper = styled.div`
  transform: scale(0.8);

  width: fit-content;
`;
